export default function($form) {
  var $params=$form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  $params.btnDebounce(function() {
    var p ={
      taskId:$params.taskId,
      appId:$params.appId,
      formId:$params.formId
    }
    if($params.comment){
      p['$comment']=$params.comment;
    }
    var btnName = $params.action;
    $params.setBtnLoading(true, btnName);
    PF.confirm('您确定送给秘书？', '提示', {type: 'info'}).then(() => {
      //p.checkGoOut = true; //检查领导是否外出
      p.actionDescription = '送秘书';
      p.secretaryActivityName='';
      if($params.taskData.taskActivityType=='notify'){
        if($params.activity.circularSecActivityName){
          p.secretaryActivityName = $params.activity.circularSecActivityName;
        }
      }else{
        if($params.activity.secActivityName){
          p.secretaryActivityName = $params.activity.secActivityName;
        }
      }
      if($params.extParams && $params.extParams.fullAuthType){
        p.fullAuthType = $params.extParams.fullAuthType;
      }
      PF.api.process.delegateSendSecretary(p).then(res => {
        if (res.success) {
          $params.formActionComplete(); //关闭窗口
        }
        $params.setBtnLoading(false, btnName);
      }).catch(() => {
        $params.setBtnLoading(false, btnName);
      });
    }).catch(() => {
      $params.setBtnLoading(false, btnName);
    });
  });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-sendsecretary.js